import React from "react";
import { Toaster, toast } from "sonner";

export default function ToastProvider({ children }) {
    return (
        <>
            {children}
            <Toaster position="top-right" richColors />
        </>
    );
}

export { toast };
